<template>
    <div style="position: relative;height:32px;padding-left:10px;">
      <el-form :inline="true" :model="search" class="demo-form-inline">
        <el-form-item :label="searchTitle" :style="soltStyle" v-if="searchTitle">
          <div class="initiate">
            <slot></slot>
            <a v-show="stat == 1 && isStatInitiate == 0" class="markRead" @click="allRead">全部标记已读</a>
          </div>
        </el-form-item>
        <el-form-item label="状态" v-show="Number(stat) !== 0">
          <el-select v-model="search.status" style="width: 124px;" placeholder="选择类型" @change="retSeatch" class="select-caret-bottom">
            <el-option v-for="list in styles" :key="list.val"  :label="list.label" :value="list.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应用" v-if="!isapply">
          <el-select v-model="search.approvalId" placeholder="选择类型" :disabled="isAppDisabled" @change="retSeatch" style="width: 124px;" popper-class="select-app-se">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in sysList" :key="item.labelId ? item.labelId : item.approvalId" :label="item.title ? item.title : item.appname" :value="item.labelId ? item.labelId : item.approvalId">
              <span style="position: relative;">
                {{ item.title ? item.title : item.appname }}
                <span class="oa-examine-bold-icon" style="top: -17px;right: -20px;" v-show="item.todonumber > 0">{{ item.todonumber }}</span>
              </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提交时间" class="oaExamine-tabs-time" style="margin-right:0;">
          <el-date-picker
            style="width:246px;"
            v-model="time"
            type="daterange"
            align="left"
            @change="retSeatch"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions2">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="search-b" :style="{ right:isTreatMe ? '140px':'' }">
        <el-input v-model="search.titlekey" :disabled="searchStatus" style="font-size:12px" placeholder="搜索内容关键字" @keyup.enter="retSeatch">
           <template #prefix>
              <i class="iconfont icon-sousuo"></i>
           </template>
        </el-input>
        <el-button :disabled="searchStatus" @click="retSeatch" type="primary">搜索</el-button>
      </div>
      <div class="batch-approv" v-if="isTreatMe && approId && approId !== '-1'" @click="$emit('changeBatch',!isBatch)">
          <i class="iconfont icon-piliangcaozuo" :class="isBatch?'batch-active':''"></i>
          <span :class="isBatch?'batch-active':''">{{ isBatch?'取消':'批量' }}</span>
      </div>
    </div>
</template>

<script>
  import { openapiUpdateuserccapprovingstatus } from '@/port/clientSide/oaExamine'
  export default {
    // isapply 这个只有个人数据下来会用到，传过来的是应用的id
    props: [ "sysList", "searchTitle", "stat", "styles", "isStatInitiate", "isapply", "soltStyle", "isTreatMe", "isBatch", "approId", "psimphaddle", 'appInfo'],
    data(){
      return {
        search:{
          titlekey: '',
          status: '',
          approvalId: '',
        },
        time: [],
        pageRoute: false,
        searchStatus: true, //应用下拉菜单未选择，搜索框不可使用
        pickerOptions2: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const today = new Date();
              const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
              const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
              const startOfDayTimestamp = startOfDay.getTime();
              const endOfDayTimestamp = endOfDay.getTime() - 1;
              picker.$emit('pick', [new Date(startOfDayTimestamp), new Date(endOfDayTimestamp)]);
            }
          },{
            text: '昨天',
            onClick(picker) {
              const today = new Date();
              const yesterday = new Date(today);
              yesterday.setDate(yesterday.getDate() - 1);
              const startOfYesterday = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0);
              const endOfYesterday = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 59);
              const startOfDayTimestamp = startOfYesterday.getTime();
              const endOfDayTimestamp = endOfYesterday.getTime();
              picker.$emit('pick', [new Date(startOfDayTimestamp), new Date(endOfDayTimestamp)]);
            }
          },{
            text: '最近三天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        simphaddle: 1
      }
    },
    mounted() {
      let _route = this.$route.path;
      this.simphaddle = this.psimphaddle
      if(_route.includes('oaFrame') || _route.includes('application')){
        this.pageRoute = true;
        this.searchStatus = false;
      }
    },
    computed:{
      isAppDisabled() {
        return this.appInfo && Object.keys(this.appInfo).length !== 0
      }
    },
    watch: {
      simphaddle(val) {
        if (val !== undefined) {
          this.$emit('update:psimphaddle',val)
        }
      },
      appInfo: {
        handler(val) {
          if (val) {
            const idx = this.sysList.find(item => item.approvalId === Number(val.appId))
            if (idx !== -1 && val.appId) {
              this.search.approvalId = Number(val.appId)
            }
          }
        },
        immediate: true
      }
    },
    methods: {
      // 全部已读
      allRead () {
        let obj = {status: 1};
        if (this.isapply) obj.approvalId = this.isapply;
        openapiUpdateuserccapprovingstatus(obj).then(res => {
          if (res.code === 0) {
            this.retSeatch();
            this.$emit('upTotal');
          }
        }).catch(e => { console.log('标记已读接口请求错误', e) })
      },
      retSeatch(val) {
        const app = this.sysList.find(item => item.approvalId == val)
        if (app && app.simphaddle !== undefined) {
          this.simphaddle = app.simphaddle
        }
        let date = JSON.parse(JSON.stringify(this.search))
        if(date.approvalId === '' && this.pageRoute == false){
          this.searchStatus = true;
          this.search.titlekey = '';
        }
        else{
          this.searchStatus = false;
        }
        if (this.time && this.time.length > 0) {
          date.startTime = this.time[0].getTime()
          date.endTime = this.time[1].getTime()
        }
        console.log(date);
        
        this.$emit('returnSearch', date)
      },
      reset() {
        console.log('重置')
        this.search = {
          titlekey: '',
          status: this.styles[0].val,
          approvalId: ''
        }
        this.time = []
        this.retSeatch()
      }
    }
  }
</script>

<style lang="scss" scoped>
// @import "~@/assets/css/clientSide/oaExamine.scss";
.markRead{
  font-size: 12px;
}
.demo-form-inline {
  padding: 0 !important;
  justify-content: flex-start !important;
  margin-top: 10px;
  background:rgba(255,255,255,1);
  border-radius:8px;
  padding: 10px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  .el-form-item {
    width: auto !important;
    padding: 0 !important;
    display: flex;
    align-items: center;
  }
}

.search-b {
  display: flex;
  align-items: center;
  ::v-deep .el-input__inner {
    border-radius: 4px 0 0 4px;
    background-color: #ffffff;
    border-width: 1px 0 1px 1px;
    border-style: solid;
    border-color: transparent !important;
  }
  ::v-deep .is-disabled {
    .el-input__inner {
      background-color: #F5F7FA;
      border-color: #E4E7ED;
    }
  }
  ::v-deep .el-button {
    border-radius: 0 2px 2px 0;
  }
}

::v-deep .el-form-item__label {
  height: 28px;
  line-height: 28px;
}
.search-b {
  width: 200px;
  position: absolute;
  right: 10px;
  top: 0px;
}

.batch-approv{
  margin-left: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333333;
  position: absolute;
  top: 5px;
  right: 20px;
  height: 28px;
  cursor: pointer;
  .batch-active {
    color: #67B2FF !important;
  }
  .icon-piliangcaozuo {
    margin-right: 5px;
    color: #A6A6A6;
  }
} 
  ::v-deep .el-button--mini {
    padding: 7px 15px;
  }
  ::v-deep .el-form--inline .el-form-item {
    margin-right: 20px;
  }
</style>

<style lang="scss">
.select-app-se{
  .el-scrollbar{
    .el-select-dropdown__item{
      overflow: initial;
    }
  }
}
</style>